<template>
  <select
    :class="classList"
    :value="value"
    :tabindex="tabindex"
    @click.stop.prevent
    @input="onInput"
    @change="onChange"
    @blur="onBlur"
    :style="styles"
  >
    <option v-if="hasEmpty" value></option>
    <option
      v-for="item in filteredItems"
      v-bind:key="item.id"
      :value="item.id"
      >{{ item.name }}</option
    >
    <slot></slot>
  </select>
</template>

<script>
import { version } from "vue";
export default {
  name: "st-select",
  data: function() {
    return {
      localValue: this.value,
    };
  },
  props: {
    value: {
      default: null,
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    tabindex: {
      type: String,
      default: "0",
    },
    hasEmpty: {
      type: Boolean,
      default: true,
    },
    blur: {
      type: Function,
    },
  },

  computed: {
    isVue3() {
      return version && parseInt(version) === 3;
    },
    classList: function() {
      return ["st-select", this.invalid && "invalid"];
    },
    filteredItems() {
      return this.items.filter((item) => !item.disable);
    },
    styles() {
      return {
        backgroundImage: `url("data:image/svg+xml;utf8,${encodeURIComponent(
          this.svgData()
        )}")`,
        backgroundColor: "#fcfcfa",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "99%",
        backgroundSize: "24px 24px",
      };
    },
  },

  watch: {
    value: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.localValue = newVal;
      }
    },
    localValue: function(newVal, oldVal) {
      if (newVal !== oldVal && !this.isVue3) {
        this.$emit("input", newVal);
      }
    },
  },

  methods: {
    onInput: function(evt) {
      this.localValue = evt.target.value;
    },
    onChange: function(evt) {
      this.localValue = evt.target.value;
      if (!this.isVue3) this.$emit("change", this.localValue);
    },
    svgData: function() {
      return require(`!svg-inline-loader!../../icons/st/ic-dropdown.svg`);
    },
    onBlur: function() {
      if (this.blur) this.blur();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../scss/main.scss";

.st-select {
  height: 3em;
  border-radius: 0.25em;
  border: $border-width--thin solid $dark-grey;
  font-size: 1em;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  cursor: pointer;
  color: $dark-grey;
  font-family: $source-sans-pro;
  width: 100%;
  box-sizing: border-box;
  padding-left: $sm;

  &:focus {
    background-color: #fff;
    border-color: $nästan-svart;
    outline: none;
  }

  &.invalid {
    border-color: $invalid;
    border-width: 0.125em;
    color: $invalid;
  }

  &:disabled {
    background-color: $off-white;
  }

  &::placeholder {
    opacity: 0.6;
  }

  .hidden {
    display: none;
  }
  option {
    color: $varm-grå-alt;
  }

  // Removes default arrow
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;

  &::-ms-expand {
    display: none; /* remove default arrow on ie10 and ie11 */
  }

  /* target Internet Explorer 9 to undo the custom arrow */
  @media screen and (min-width: 0\0) {
    background: none\9;
    padding: 0.3125em\9;
  }
}
</style>
